import { Link, NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Col, Dropdown, Row } from "react-bootstrap";
import { logout } from "store/auth";
import { useLanguage } from "hooks";
import { Icons, Avatar, Skeletons } from "components";

export default function Login() {
  const dispatch = useDispatch();
  const { loading, isLoggedIn, user } = useSelector((state) => state.auth); // call data from auth store
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const handleLogout = () => dispatch(logout());

  return isLoggedIn ? (
    <Dropdown>
      <Dropdown.Toggle
        id="dropdown-split-basic"
        variant="none"
        className="p-0 border-0"
      >
        <Row className="align-items-center p-0 m-0">
          <Col xl={4} lg={4} md={5} sm={12} xs={12} className="p-0 float-start">
            <div className="d-flex justify-content-end">
              <Avatar image={user.image} className="d-block" />
            </div>
          </Col>
          <Col
            xl={8}
            md={7}
            sm={8}
            xs={12}
            className="p-0 d-none d-md-block text-wrap"
          >
            <p className="fw-bold text-primary cut-text-1">{user.name}</p>
          </Col>
        </Row>
      </Dropdown.Toggle>
      <Dropdown.Menu className="rounded-1">
        <div>
          <NavLink className="dropdown-item" to="/profile/">
            <div className="d-flex align-items-center border-0 gap-4 py-3 px-3">
              <Icons.UserCircle width="24" />
              <p> {language.profile} </p>
            </div>
          </NavLink>
          <NavLink className="dropdown-item" to="/profile/history">
            <div className="d-flex align-items-center border-0 gap-4 py-3 px-3">
              <Icons.History width="24" />
              <p> {language.history} </p>
            </div>
          </NavLink>
          <NavLink className="dropdown-item" to="/profile/favourite">
            <div className="d-flex align-items-center border-0 gap-4 py-3 px-3">
              <Icons.Favourite width="24" />
              <p> {language.favourite} </p>
            </div>
          </NavLink>
          <Dropdown.Item>
            <div
              onClick={handleLogout}
              className="d-flex align-items-center border-0 gap-4 py-3 px-3"
            >
              <Icons.Logout width="24" />
              <p> {language.logout} </p>
            </div>
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  ) : (
    <>
      {!loading ? (
        <Link to="/login">
          <Row className="align-items-center p-0 m-0">
            <Col xs={12} className="p-0 d-flex align-items-center">
              <Icons.UserCircle
                fill="#951B81"
                className="d-none d-md-inline-block mx-1"
              />
              <p className="text-primary fw-medium d-none d-xl-block">
                {language.login}
              </p>
              <p className="text-primary fw-medium d-xl-none">
                {language.smallLogin}
              </p>
            </Col>
          </Row>
        </Link>
      ) : (
        <Skeletons.UserCardSkeleton />
      )}
    </>
  );
}
